import React from 'react';
import styled from 'styled-components';
import { ProgressBar } from '@superops/ui-design-system';
import { DisabledTag } from '@nile/components';

function ProgressCell(props) {
  const { cell } = props;
  const data = cell.row.original || cell.row.values;
  const { totalTasks, completedTasks } = data;
  const calculateProgress = (completed, total) => {
    if (!total) {
      return 0;
    }
    return Math.floor((completed / total) * 100);
  };
  return (
    <div className="progressBar flex actr w100">
      {totalTasks ? (
        <ProgressBar
          progress={calculateProgress(completedTasks, totalTasks)}
          size="small"
        />
      ) : (
        ''
      )}
      {totalTasks ? (
        <div className="ml8">{`${completedTasks}/${totalTasks}`}</div>
      ) : (
        <DisabledTag>NA</DisabledTag>
      )}
    </div>
  );
}

export default ProgressCell;
